import React from 'react';

export default function SingleBar(props) {
    return (
        <>
            <div className="flex justify-between mb-1">
                <span className="text-sm font-medium text-blue-700 dark:text-black">{props.stype}</span>
                <span className="text-sm font-medium text-blue-700 dark:text-black">{props.prog2}</span>
            </div>
            <div className="w-full h-2.5 bg-[#dce8f8]">
                <div className={`bg-blue-400 h-2.5 `} style={{width: props.prog }}></div>
            </div>
        </>
    )
}
